module.exports = __webpack_public_path__ + "static/media/siste.56f189c2.png";